import UserGroupPicker from '../UserGroupPicker';
import { DialogUserGroupPickerProps } from './types';
import { Stack } from '@mantine/core';
import UserTile from '@app/shared/ui-kit/atoms/UserTile';

export default function DialogUserGroupPicker({
  ...props
}: DialogUserGroupPickerProps) {
  return (
    <Stack w={400} maw="95%">
      <UserTile
        user={props.user}
        rootContainerProps={{ w: '100%' }}
        containerProps={{ w: '100%', justify: 'flex-end' }}
      />
      <UserGroupPicker {...props} from="dialog" />
    </Stack>
  );
}
